import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import StandardDropdown from '@wix/da-shared-react/pkg/Dropdown/Preset/StandardDropdown';
import { PostsSortOrder } from '../../../../../../types/posts';

interface Props {
  value: PostsSortOrder;
  onChange: (value: PostsSortOrder) => void;
  className?: string;
}

const SortOrderSwitcher: React.FC<Props> = ({ value, onChange, className }) => {
  const { t } = useTranslation();
  const items = useMemo(
    () => [
      { value: PostsSortOrder.NEWEST, label: t('common.sortOrder.newest') },
      { value: PostsSortOrder.OLDEST, label: t('common.sortOrder.oldest') },
    ],
    [t]
  );
  return (
    <StandardDropdown
      className={className}
      menuLabel={t('common.sortOrder')}
      menuAlignment="left"
      selectedValue={value}
      onSelect={onChange}
      items={items}
    />
  );
};
SortOrderSwitcher.displayName = 'SortOrderSwitcher';
export default SortOrderSwitcher;
